import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import { useCommentsRoot } from '../Root';

const Sort = dynamic(() => import('./Sort'));

const Header = ({
  children = null,
  className,
  emptyListComponent: EmptyListComponent = null,
  isSortActive = true,
}) => {
  const { isCommentsListEmpty } = useCommentsRoot();

  return (
    <>
      <div className={twJoin('flex items-center justify-end', className)}>
        {isSortActive && <Sort />}
      </div>
      {children}
      {isCommentsListEmpty && EmptyListComponent && <EmptyListComponent />}
    </>
  );
};

Header.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  emptyListComponent: PropTypes.shape(),
  isSortActive: PropTypes.bool,
};

export default Header;
